module.exports = __webpack_public_path__ + "media/images/webpage/shared/imgproxy/blank-large-480ecf60ec01fd6abeddfd86f8006592.svg";